const _excluded = ["className", "children", "name", "value", "checked", "onChange", "id", "disabled"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import styles from "./RadioButton.module.scss";
export const RadioButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      className,
      children,
      name,
      value,
      checked,
      onChange: _onChange,
      id,
      disabled
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    setIsChecked(!!checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement("label", _extends({
    ref: ref,
    "aria-disabled": disabled,
    "aria-checked": isChecked,
    className: cn(styles.root, className)
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: styles.radioButton,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("input", {
    className: styles.nativeRadio,
    "data-testid": rest['data-testid'] && "".concat(rest['data-testid'], "-input"),
    type: "radio",
    value: value,
    disabled: disabled,
    name: name,
    id: id,
    checked: _onChange || checked ? isChecked : undefined,
    onChange: e => {
      if (_onChange) {
        //controlled
        e.persist();
        _onChange(e);
      } else {
        //uncontrolled
        setIsChecked(e.target.checked);
      }
    },
    tabIndex: -1
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.checkmark
  })), children);
});
RadioButton.displayName = 'RadioButton';